import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Comment fonctionne votre service de prospection ?',
      answer: 'Nous mettons en place une stratégie de prospection multi-canal (email, LinkedIn, téléphone) adaptée à votre cible. Nous créons les messages, gérons les campagnes et qualifions les leads pour vous fournir uniquement des rendez-vous avec des prospects intéressés par votre offre.'
    },
    {
      question: 'Combien de rendez-vous puis-je espérer par mois ?',
      answer: 'Le nombre de rendez-vous varie selon votre secteur, votre offre et la qualité de votre cible. En moyenne, nos clients obtiennent entre 5 et 15 rendez-vous qualifiés par mois. Nous définissons ensemble des objectifs réalistes lors de notre première réunion stratégique.'
    },
    {
      question: 'Comment sont qualifiés les rendez-vous ?',
      answer: 'Un rendez-vous est considéré comme qualifié lorsque le prospect correspond à votre cible idéale, a exprimé un intérêt pour votre solution et a accepté un rendez-vous à une date précise. Nous vérifions également que le prospect a le pouvoir de décision ou d\'influence dans le processus d\'achat.'
    },
    {
      question: 'Quelle est la durée minimale d\'engagement ?',
      answer: 'Il n\'y a pas de durée minimale d\'engagement. Vous payez les frais d\'abonnement mensuel, puis uniquement pour les rendez-vous qualifiés et effectués. Vous pouvez arrêter à tout moment sans frais supplémentaires.'
    },
    {
      question: 'Dans quels secteurs d\'activité intervenez-vous ?',
      answer: 'Nous travaillons principalement avec des entreprises B2B dans divers secteurs comme l\'IT, les services professionnels, la finance, l\'immobilier, et l\'industrie. Notre approche est adaptable à la plupart des secteurs d\'activité qui nécessitent une prospection commerciale qualitative.'
    },
    {
      question: 'Comment mesurez-vous les résultats de vos campagnes ?',
      answer: 'Nous fournissons des rapports hebdomadaires détaillant les performances de chaque canal (taux d\'ouverture, taux de réponse, nombre de rendez-vous fixés, etc.). Nous organisons également des points réguliers pour analyser les résultats et optimiser continuellement notre approche.'
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-4">Questions fréquentes</h2>
          <p className="text-xl text-growlyy-gray-dark max-w-2xl mx-auto">
            Tout ce que vous devez savoir sur notre service de prospection
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4">
              <button
                className={`w-full text-left p-5 rounded-lg flex justify-between items-center transition duration-300 ${
                  openIndex === index 
                    ? 'bg-growlyy-primary-light bg-opacity-20 text-white rounded-b-none' 
                    : 'bg-growlyy-gray-light hover:bg-growlyy-primary-light hover:bg-opacity-10'
                }`}
                onClick={() => toggleFaq(index)}
              >
                <span className={`font-semibold text-lg ${openIndex === index ? 'text-white' : 'text-growlyy-primary'}`}>
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <FaChevronUp className="text-white" />
                ) : (
                  <FaChevronDown className="text-growlyy-gray-dark" />
                )}
              </button>
              {openIndex === index && (
                <div className="p-5 bg-white border border-growlyy-primary-light border-t-0 rounded-b-lg">
                  <p className="text-growlyy-gray-dark">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ; 